import { useCurrentUser } from "../../../AuthWrapper2/hooks/useCurrentUser.js";
import { getSystemInfoTarget } from "../constants.js";
import { useSystemInfoForTarget } from "./useSystemInfoForTarget.js";
import { useAppList } from "../../../AppWrapper2/hooks/useAppList.js";
import dayjs from "dayjs";
//#region src/modules/SystemInfo/shared/hooks/useNewSystemInfoCount.tsx
var lastMonth = dayjs().subtract(1, "month").toISOString();
var useNewSystemInfoCount = () => {
	const { userClientMetadata } = useCurrentUser();
	const { currentAppId } = useAppList();
	const targetApp = getSystemInfoTarget(currentAppId);
	const lastChangelogView = userClientMetadata?.webClientData?.["systemInfoLastSawDate"] || lastMonth;
	const { data } = useSystemInfoForTarget(targetApp && {
		pagination: { limit: 0 },
		publishedAfterDate: lastChangelogView,
		target: targetApp
	}, { callOnVisibleTimeout: 36e5 });
	return data?.total;
};
//#endregion
export { useNewSystemInfoCount };

//# sourceMappingURL=useNewSystemInfoCount.js.map